import axios from "axios";

//const url = "http://localhost:3000/posts";
const url = "https://attackontitanbegins.herokuapp.com/posts";

export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
export const lovePost = (id) => axios.patch(`${url}/${id}/lovePost`);
export const updatePost = (id, updatedPost) =>
  axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);
